import Vue from 'vue';
import Router from 'vue-router';
import { Message } from 'element-ui';
import store from '../store';
import Layout from '../layout/Layout.vue';
import Login from '../views/auth/Login.vue';
import { hasMenuPathAccess } from '../utils/menuAccess';

Vue.use(Router);

export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home', menuOptional: true }
      },
      {
        path: 'tenant/agent',
        name: 'AgentList',
        component: () => import('../views/tenant/AgentList.vue')
      },
      {
        path: 'tenant/school',
        name: 'SchoolList',
        component: () => import('../views/tenant/SchoolList.vue')
      },
      {
        path: 'tenant/school/staff',
        name: 'StaffList',
        component: () => import('../views/tenant/StaffList.vue')
      },
      {
        path: 'tenant/school/grade',
        name: 'GradeList',
        component: () => import('../views/tenant/GradeList.vue')
      },
      {
        path: 'tenant/school/class',
        name: 'ClassList',
        component: () => import('../views/tenant/ClassList.vue')
      },
      {
        path: 'tenant/school/student',
        name: 'StudentList',
        component: () => import('../views/tenant/StudentList.vue')
      },
      {
        path: 'user/mobile',
        name: 'MobileUserList',
        component: () => import('../views/user/MobileUserList.vue')
      },
      {
        path: 'user/member',
        name: 'MemberList',
        component: () => import('../views/user/MemberList.vue')
      },
      {
        path: 'user/mobile-bind',
        name: 'MobileBindList',
        component: () => import('../views/user/MobileBindList.vue')
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/personal/Profile.vue'),
        meta: { menuOptional: true }
      },
      {
        path: 'todo',
        name: 'TodoList',
        component: () => import('../views/personal/TodoList.vue'),
        meta: { menuOptional: true }
      },
      {
        path: 'monitor/log',
        name: 'SysUserLog',
        component: () => import('../views/monitor/SysUserLog.vue')
      },
      {
        path: 'monitor/exception',
        name: 'SysException',
        component: () => import('../views/monitor/SysException.vue')
      },
      {
        path: 'auth/roles',
        name: 'AuthRoleList',
        component: () => import('../views/auth/RoleList.vue')
      },
      {
        path: 'system/user',
        name: 'SysUserList',
        component: () => import('../views/auth/SysUserList.vue')
      },
      {
        path: 'auth/module',
        name: 'AuthMenuModule',
        component: () => import('../views/auth/MenuModule.vue'),
        meta: { title: '菜单模块' }
      },
      {
        path: 'resource/question/public',
        name: 'PublicQuestionList',
        component: () => import('../views/resource/PublicQuestionList.vue')
      },
      {
        path: 'resource/question/manage',
        name: 'PublicQuestionListManage',
        component: () => import('../views/resource/PublicQuestionListManage.vue')
      },
      {
        path: 'resource/question/school',
        name: 'SchoolQuestionList',
        component: () => import('../views/resource/SchoolQuestionList.vue')
      },
      {
        path: 'resource/question/chapter',
        name: 'QuestionPickChapter',
        component: () => import('../views/resource/question-pick/QuestionPickPage.vue'),
        meta: { title: '章节挑题', questionPickMode: 'chapter' }
      },
      {
        path: 'resource/question/knowledge',
        name: 'QuestionPickKnowledge',
        component: () => import('../views/resource/question-pick/QuestionPickPage.vue'),
        meta: { title: '知识点挑题', questionPickMode: 'knowledge' }
      },
      {
        path: 'resource/question/my',
        name: 'QuestionPickMy',
        component: () => import('../views/resource/question-pick/QuestionPickPage.vue'),
        meta: { title: '我的题目', questionPickMode: 'my' }
      },
      {
        path: 'resource/question/my-manage',
        name: 'MyQuestionList',
        component: () => import('../views/resource/MyQuestionList.vue'),
        meta: { title: '我的题目维护' }
      },
      {
        path: 'resource/question/favorite',
        name: 'QuestionPickFavorite',
        component: () => import('../views/resource/question-pick/QuestionPickPage.vue'),
        meta: { title: '收藏挑题', questionPickMode: 'favorite' }
      },
      {
        path: 'resource/question/smart',
        name: 'QuestionPickSmart',
        component: () => import('../views/resource/question-pick/SmartQuestionPickPage.vue'),
        meta: { title: '智能挑题' }
      },
      {
        path: 'resource/question/wrong',
        redirect: to => ({ name: 'ErrorBankList', query: to.query })
      },
      {
        path: 'resource/error-bank/list',
        name: 'ErrorBankList',
        component: () => import('../views/resource/WrongQuestionStat.vue'),
        meta: { title: '错题题库' }
      },
      {
        path: 'resource/error-bank/import',
        name: 'ErrorBankImport',
        component: () => import('../views/resource/ErrorBankImport.vue'),
        meta: { title: '错题入库' }
      },
      {
        path: 'resource/error-bank/student',
        name: 'StudentErrorBook',
        component: () => import('../views/resource/StudentErrorBook.vue'),
        meta: { title: '学生错题本' }
      },
      {
        path: 'resource/paper',
        name: 'PaperList',
        component: () => import('../views/resource/PaperList.vue')
      },
      {
        path: 'resource/paper/public',
        name: 'PaperCenterPublic',
        component: () => import('../views/resource/paper-center/PaperCenterList.vue'),
        meta: { title: '公共试卷', paperCenterMode: 'public' }
      },
      {
        path: 'resource/paper/my',
        name: 'PaperCenterMy',
        component: () => import('../views/resource/paper-center/PaperCenterList.vue'),
        meta: { title: '我的卷子', paperCenterMode: 'my' }
      },
      {
        path: 'resource/paper/compose',
        name: 'PaperCenterMyCompose',
        component: () => import('../views/resource/paper-center/PaperCenterList.vue'),
        meta: { title: '我的组卷', paperCenterMode: 'compose' }
      },
      {
        path: 'resource/paper/union',
        redirect: '/exam/joint'
      },
      {
        path: 'exam/joint/:id/manage',
        name: 'JointExamManage',
        component: () => import('../views/exam/JointExamManage.vue'),
        meta: { title: '联考管理详情' }
      },
      {
        path: 'exam/joint/:id/analysis',
        name: 'JointExamAnalysis',
        component: () => import('../views/exam/JointExamAnalysis.vue'),
        meta: { title: '联考成绩分析' }
      },
      {
        path: 'exam/scan-task',
        name: 'ScanTaskList',
        component: () => import('../views/exam/ScanTaskList.vue'),
        meta: { title: '扫描任务' }
      },
      {
        path: 'exam/answer',
        name: 'AnswerList',
        component: () => import('../views/exam/AnswerList.vue'),
        meta: { title: '答卷管理' }
      },
      {
        path: 'exam/dispatch',
        name: 'DispatchList',
        component: () => import('../views/exam/DispatchList.vue'),
        meta: { title: '下发任务' }
      },
      {
        path: 'exam/session',
        name: 'ExamSessionList',
        component: () => import('../views/exam/SessionList.vue'),
        meta: { title: '考试管理' }
      },
      {
        path: 'exam/grading',
        name: 'ExamGradingWorkbench',
        component: () => import('../views/exam/GradingWorkbench.vue'),
        meta: { title: '在线批阅' }
      },
      {
        path: 'exam/affair',
        name: 'ExamAffairList',
        component: () => import('../views/exam/affair/AffairList.vue'),
        meta: { title: '考务管理' }
      },
      {
        path: 'exam/affair/create',
        name: 'ExamAffairCreate',
        component: () => import('../views/exam/affair/AffairWizard.vue'),
        meta: { title: '新增考务' }
      },
      {
        path: 'exam/affair/:id/edit',
        name: 'ExamAffairEdit',
        component: () => import('../views/exam/affair/AffairWizard.vue'),
        meta: { title: '编辑考务' }
      },
      {
        path: 'exam/affair/:id/detail',
        name: 'ExamAffairDetail',
        component: () => import('../views/exam/affair/AffairDetail.vue'),
        meta: { title: '考务详情' }
      },
      {
        path: 'exam/affair/:id/export-preview',
        name: 'ExamAffairExportPreview',
        component: () => import('../views/exam/affair/export/AffairExportPreview.vue'),
        meta: { title: '考务导出预览' }
      },
      {
        path: 'exam/session/create',
        name: 'ExamSessionCreate',
        component: () => import('../views/exam/SessionForm.vue'),
        meta: { title: '新建考试' }
      },
      {
        path: 'exam/session/:id/edit',
        name: 'ExamSessionEdit',
        component: () => import('../views/exam/SessionForm.vue'),
        meta: { title: '修改考试' }
      },
      {
        path: 'exam/session/:examId/sheet',
        name: 'ExamAnswerSheetEditor',
        component: () => import('../views/exam/AnswerSheetEditor.vue'),
        meta: { title: '在线制作答题卡' }
      },
      {
        path: 'exam/session/:sessionId/marking',
        name: 'ExamSessionMarking',
        component: () => import('../views/exam/MarkingEditor.vue'),
        meta: { title: '阅卷标记' }
      },
      {
        path: 'exam/session/:sessionId/crop-preview',
        name: 'ExamSessionCropPreview',
        component: () => import('../views/exam/CropPreview.vue'),
        meta: { title: '切割结果预览' }
      },
      {
        path: 'exam/session/:sessionId/grading-assign',
        name: 'ExamGradingTaskAssign',
        component: () => import('../views/exam/GradingTaskAssign.vue'),
        meta: { title: '任务分配' }
      },
      {
        path: 'exam/session/:sessionId/grading-workspace',
        name: 'ExamGradingTaskWorkspace',
        component: () => import('../views/exam/GradingTaskWorkspace.vue'),
        meta: { title: '进入批改' }
      },
      {
        path: 'homework/assignment',
        name: 'HomeworkList',
        component: () => import('../views/homework/HomeworkList.vue'),
        meta: { title: '作业管理' }
      },
      {
        path: 'homework/assignment/create',
        name: 'HomeworkCreate',
        component: () => import('../views/homework/HomeworkForm.vue'),
        meta: { title: '新建作业' }
      },
      {
        path: 'homework/assignment/:id/edit',
        name: 'HomeworkEdit',
        component: () => import('../views/homework/HomeworkForm.vue'),
        meta: { title: '编辑作业' }
      },
      {
        path: 'homework/assignment/:id',
        name: 'HomeworkDetail',
        component: () => import('../views/homework/HomeworkDetail.vue'),
        meta: { title: '作业详情' }
      },
      {
        path: 'homework/assignment/:id/correct/:submissionId',
        name: 'HomeworkCorrectWorkspace',
        component: () => import('../views/homework/HomeworkCorrectWorkspace.vue'),
        meta: { title: '批改校正' }
      },
      {
        path: 'homework/assignment/:id/analysis/:studentId',
        name: 'HomeworkStudentAnalysis',
        component: () => import('../views/homework/HomeworkStudentAnalysis.vue'),
        meta: { title: '学情报告' }
      },
      {
        path: 'resource/paper/custom',
        name: 'CustomExerciseList',
        component: () => import('../views/personal/CustomExerciseList.vue'),
        meta: { title: '个性组卷' }
      },
      {
        path: 'exam/joint',
        name: 'JointExamList',
        component: () => import('../views/exam/JointExamList.vue'),
        meta: { title: '联考管理' }
      },
      {
        path: 'resource/paper/union/:id/manage',
        redirect: to => ({ name: 'JointExamManage', params: { id: to.params.id } })
      },
      {
        path: 'resource/paper/union/:id/analysis',
        redirect: to => ({ name: 'JointExamAnalysis', params: { id: to.params.id } })
      },
      {
        path: 'resource/video',
        name: 'VideoList',
        component: () => import('../views/resource/VideoList.vue')
      },
      {
        path: 'resource/paper-entry',
        name: 'PaperEntryTaskList',
        component: () => import('../views/resource/PaperEntryTaskList.vue')
      },
      {
        path: 'resource/paper-set',
        name: 'PaperSetList',
        component: () => import('../views/resource/PaperSetList.vue')
      },
      {
        path: 'resource/easy-mistake-relation',
        name: 'EasyMistakeRelationList',
        component: () => import('../views/resource/EasyMistakeRelationList.vue')
      },
      {
        path: 'resource/paper/compose-center/:paperId',
        name: 'PaperComposeCenter',
        component: () => import('../views/resource/PaperComposeCenter.vue')
      },
      {
        path: 'resource/paper/compose/:paperId',
        name: 'PaperCompose',
        component: () => import('../views/resource/PaperCompose.vue')
      },
      {
        path: 'resource/paper/preview/:paperId',
        name: 'PaperPreview',
        component: () => import('../views/resource/PaperPreview.vue')
      },
      {
        path: 'dict/subject',
        name: 'SubjectList',
        component: () => import('../views/dict/SubjectList.vue')
      },
      {
        path: 'dict/region',
        name: 'RegionList',
        component: () => import('../views/dict/RegionList.vue')
      },
      {
        path: 'dict/textbook',
        name: 'TextbookDict',
        component: () => import('../views/dict/TextbookDict.vue')
      },
      {
        path: 'dict/paper-question-type',
        name: 'PaperTypeDict',
        component: () => import('../views/dict/PaperTypeDict.vue')
      },
      {
        path: 'dict/question-type',
        name: 'QuestionTypeDict',
        component: () => import('../views/dict/QuestionTypeDict.vue')
      },
      {
        path: 'dict/core-outline',
        name: 'CoreOutlineDict',
        component: () => import('../views/dict/CoreOutlineDict.vue')
      },
      {
        path: 'dict/textbook-knowledge',
        name: 'TextbookKnowledgeDict',
        component: () => import('../views/dict/TextbookKnowledgeDict.vue')
      },
      {
        path: 'analysis/school',
        name: 'SchoolLearningAnalysis',
        component: () => import('../views/analysis/SchoolAnalysis.vue'),
        meta: { title: '学校学情分析' }
      },
      {
        path: 'analysis/grade',
        name: 'GradeLearningAnalysis',
        component: () => import('../views/analysis/GradeAnalysis.vue'),
        meta: { title: '年级学情分析' }
      },
      {
        path: 'analysis/class',
        name: 'ClassLearningAnalysis',
        component: () => import('../views/analysis/ClassAnalysis.vue'),
        meta: { title: '班级分析及讲评' }
      },
      {
        path: 'analysis/single-subject',
        component: () => import('../views/analysis/single-subject/AnalysisTabShell.vue'),
        meta: { title: '学情分析' },
        redirect: '/analysis/single-subject/list',
        children: [
          {
            path: 'list',
            name: 'SingleSubjectReportList',
            component: () => import('../views/analysis/single-subject/SingleSubjectReportList.vue'),
            meta: { title: '单科报告' }
          },
          {
            path: 'report/:examSessionId',
            name: 'ExamSessionReport',
            component: () => import('../views/analysis/single-subject/ExamSessionReportLayout.vue'),
            meta: { title: '查看报告' }
          },
          {
            path: 'report/:examSessionId/student/:studentId',
            redirect: (to) => ({
              name: 'ExamSessionReport',
              params: { examSessionId: to.params.examSessionId },
              query: {
                panel: 'score-sheet',
                studentId: to.params.studentId,
                ...to.query
              }
            })
          }
        ]
      },
      {
        path: 'analysis/multi-subject/list',
        name: 'MultiSubjectReportList',
        component: () => import('../views/analysis/multi-subject/MultiSubjectReportList.vue'),
        meta: { title: '多科报告' }
      },
      {
        path: 'analysis/multi-subject/report/:reportId',
        name: 'MultiSubjectReportDetail',
        component: () => import('../views/analysis/multi-subject/MultiSubjectReportLayout.vue'),
        meta: { title: '多科报告详情' }
      },
      {
        path: 'analysis/in-class',
        name: 'InClassReport',
        component: () => import('../views/analysis/InClassReport.vue'),
        meta: { title: '课中报告' }
      },
      {
        path: 'analysis/error-questions',
        name: 'ErrorQuestionOrganize',
        component: () => import('../views/analysis/ErrorQuestionOrganize.vue'),
        meta: { title: '错题整理' }
      },
      {
        path: 'analysis/weak-knowledge',
        name: 'WeakKnowledgeAnalysis',
        component: () => import('../views/analysis/WeakKnowledgeAnalysis.vue'),
        meta: { title: '薄弱知识点' }
      },
      {
        path: 'admin/ai/config',
        name: 'AiConfig',
        component: () => import('../views/admin/ai/AiConfigPage.vue'),
        meta: { title: 'AI连接配置' }
      },
      {
        path: 'admin/ai/prompts',
        name: 'AiPromptList',
        component: () => import('../views/admin/ai/AiPromptList.vue'),
        meta: { title: 'AI提示词' }
      },
      {
        path: 'admin/ai/request-logs',
        name: 'AiRequestLogList',
        component: () => import('../views/admin/ai/AiRequestLogList.vue'),
        meta: { title: 'AI请求记录' }
      }
    ]
  }
];

const router = new Router({
  mode: 'history',
  base: '/', // 与后端 context-path 对齐，如有调整可修改
  routes: constantRoutes
});

// Vue Router 3：重复 push/replace 到当前地址时不抛未捕获异常
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err);
    }
  });
};
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err);
    }
  });
};

router.beforeEach(async (to, from, next) => {
  const hasToken = store.getters['user/token'];

  if (to.matched.some(record => record.meta.public)) {
    return next();
  }

  if (!hasToken) {
    return next({ path: '/login', query: { redirect: to.fullPath } });
  }

  if (!store.getters['user/userLoaded']) {
    try {
      await store.dispatch('user/fetchUserInfo');
    } catch (e) {
      await store.dispatch('user/logout');
      return next('/login');
    }
  }

  const menuOptional = to.matched.some((record) => record.meta && record.meta.menuOptional);
  if (!menuOptional) {
    const menus = store.getters['user/menus'] || [];
    if (!hasMenuPathAccess(menus, to.path)) {
      Message.warning('当前账号没有该页面权限，请联系管理员开通');
      if (to.path === '/dashboard') {
        return next(false);
      }
      return next({ path: '/dashboard', replace: true });
    }
  }

  next();
});

export default router;

